export default __webpack_public_path__ + "static/media/vehicle-detail-partfailfast.5619b05b.gif";